import { AgentLogoType, Property } from '../../types/property';

/*
 * Returns agents logos urls in array
 */

interface AgentLogo {
  url: string;
  backgroundColor: string;
}

export const getLogosOfType = (property: Property, type: 'ALTERNATIVE' | 'PREMIER' | 'STANDARD'): AgentLogoType[] => {
  if (property.agentLogos) {
    const logos = property.agentLogos.filter((l) => !!l.url && l.logoType === type);

    return logos.slice(0, 3);
  }

  return [];
};

const getAgentLogos = (property: Property): AgentLogo[] => {
  if (property.agents) {
    const logos: AgentLogo[] = property.agents
      .filter((a) => !!a.logo?.standard)
      .map((a) => ({
        url: a.logo?.standard || '',
        backgroundColor: a.logo?.standardBackgroundColour || '',
      }));

    return logos.slice(0, 3);
  }

  return [];
};

export default getAgentLogos;
